import type {
  ApiResponse,
  Audience,
  BrandComparisonRequest,
  BrandCoverageEntry,
  Category,
  EquivalentSizeRequest,
  VerificationStatus,
} from '@/types/domain';

const BASE = 'https://size-match.brendanlowen.workers.dev/api';

async function request<T>(path: string, init?: RequestInit): Promise<ApiResponse<T>> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
  });
  const body = (await res.json()) as ApiResponse<T>;
  return body;
}

export interface BrandOption {
  id: string;
  name: string;
  slug: string;
  status: 'active' | 'locked';
  verificationStatus: VerificationStatus;
  logoUrl: string | null;
  isAvailable: boolean;
  reasonUnavailable: string | null;
}

export const api = {
  listBrandsFor(audience: Audience, category: Category) {
    return request<BrandOption[]>(`/brands?audience=${audience}&category=${category}`);
  },

  getChart(brandSlug: string, audience: Audience, category: Category) {
    return request(`/charts?brand=${encodeURIComponent(brandSlug)}&audience=${audience}&category=${category}`);
  },

  compareEquivalent(body: EquivalentSizeRequest) {
    return request('/compare/equivalent', { method: 'POST', body: JSON.stringify(body) });
  },

  compareBrandToBrand(body: BrandComparisonRequest) {
    return request('/compare/brand-to-brand', { method: 'POST', body: JSON.stringify(body) });
  },

  getCoverage() {
    return request<BrandCoverageEntry[]>('/coverage');
  },
};
